import { useLocation } from 'react-router-dom';

export function useIsGift(): boolean {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('isGift') === 'true';
}
